module.exports = __webpack_public_path__ + "img/influencer--active.bd372c9b.svg";